module.exports = __webpack_public_path__ + "img/icon-404.6eeb6e7.svg";